import { useQuery } from '@apollo/client';
import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DashboardWrap from '../../components/DashboardWrap';
import { GET_ADMIN_REPAYMENT_BY_ID } from '../../graphql/admin_queries';
import GoBackIcon from '../../svgs/GoBackIcon';
import { cleanUpAdminSingleLoanRecord } from '../../utils/helpers';
import PropertyComp from '../../components/PropertyComp';
import './AdminRepaymentDetails.scss';
import RepaymentSummary from './RepaymentSummary';
import RepaymentSchedule from './RepaymentSchedule';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import PermissionDenied from '../PermissionDenied';
import EmptyPageLoader from '../../components/EmptyPageLoader';

const AdminRepaymentDetails = () => {
  const history = useHistory();
  const { repaymentId } = useParams<{ repaymentId: string }>();
  const { data, refetch, loading } = useQuery<
    {
      getRepaymentByIdCa: any;
    },
    { id: string }
  >(GET_ADMIN_REPAYMENT_BY_ID, { variables: { id: repaymentId } });

  const getRepaymentData = useMemo(() => data?.getRepaymentByIdCa, [data]);

  const payload = cleanUpAdminSingleLoanRecord(getRepaymentData?.loan);
  const property = payload?.property || [];

  return (
    <DashboardWrap>
      <RolesAndPermissionGuard permissionName="can-get-repayment-by-id" hasErrorTemplate={<PermissionDenied height="100vh" />}>
        <div className="repayments-details-dashboard-loader" style={{ display: loading ? 'block' : 'none' }}>
          <EmptyPageLoader />
        </div>

        <div className="repayments-details-cover" style={{ display: loading ? 'none' : 'block' }}>
          <div className="title">
            <GoBackIcon onClick={() => history?.goBack()} />
            Repayments
          </div>
          <div className="loan-ref-id-and-badge">
            <span className="loan-ref-span">Repayment ID : :</span>
            <span className="ref-no-span">{getRepaymentData?.id}</span>
            <div className="loan-badge-span">REPAYMENT</div>
          </div>

          <RepaymentSummary payload={payload} />
          <RepaymentSchedule payload={payload} refetchLoan={refetch} />
          {
            property && (
            <div style={{ marginTop: '32px' }}>
              <PropertyComp property={property} width="800px" />
            </div>
            )
          }

        </div>
      </RolesAndPermissionGuard>
    </DashboardWrap>
  );
};
export default AdminRepaymentDetails;
